export default {
    'game_selector_Dashboard': '报表',
    'game_selector_tab1': '游戏',
    'game_selector_tab2': '工作室&企业',
    'game_selector_input_placeholder': '搜索游戏',
    'game_selector_recent_title': '最近浏览',
    'game_selector_follow_title': '我的收藏',
    'game_selector_game_list_title': '游戏列表',
    'game_selector_no_authority_title': '无权限游戏',
    'game_selector_access': '去申请',
    'game_selector_no_data': '无匹配结果',
    'game_selector_no_Search_metrics': '搜索目录/指标',
    'game_selector_title_game_related': '我的游戏',
    'game_selector_title_game_all': '所有游戏',
    'game_selector_title_game_new': '最新上线',

    'game_selector_following_bubble': '已收藏',
    'game_selector_follow_bubble': '收藏',
    'game_selector_edit_btn': '编辑',
    'game_selector_edit_title': '编辑我的收藏',
    'game_selector_edit_all_game': '所有游戏',
    'game_selector_edit_select_game': '已选择',
    'game_selector_all_tab': '全部',
    'game_selector_access_tab': '有权限',
    'game_selector_no_access_tab': '无权限',
    'game_selector_request_access': '申请权限',
    'game_selector_request_access_bubble': '已有全部版本权限',

    'game_selector_search_text': '搜索',

    'game_selector_confirm': '确认',
    'game_selector_cancel': '取消',
    'game_selector_game_table_header': '游戏',
    'game_selector_game_no_autority': '无权限游戏',
    'game_selector_game_get_access': '获取权限',
    'game_selector_game_no_access' : 'Dashboard的游戏权限申请请联系DataBrain-Studio业务对接人员或Sallyxue@tencent.com',
    
    'game_selector_recent_game_no_data': '暂无最近查看的游戏，请到 {link1} 或 {link2} 查找游戏',
    'game_selector_follow_game_no_data': '暂无关注的游戏，请到 {link1} 或 {link2} 关注游戏',
} 
